var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[_c('p',{staticClass:"text-right pr-4 d-none"},[_vm._v("Your IP : "),_c('span',{staticClass:"ip-text"})])])}]

export { render, staticRenderFns }